import React from 'react';
import { Link } from 'react-router-dom';
import green_switch from '../assets/images/green_switch.png'
import purpledot from '../assets/images/purple_squre_dots.b6e7dbcc.svg';
import yellowdot from '../assets/images/yellow_squre_dots.a8deef14.svg';
import slry1 from '../assets/images/slry1.png'
import slry2 from '../assets/images/slry2.png'
import slry3 from '../assets/images/slry3.png'
import slry4 from '../assets/images/slry4.png'
import greenTickFill from '../assets/images/greenTickFill.svg'

function UsCpaSalary() {
    return (
        <>
            <div class="overflow-hidden bg-placement-hero bg-cover w-full">
                <div class="max-w-7xl m-auto relative isolate px-6 pt-14 lg:px-8 h-[55%] md:h-[50%] lg:h-[80%] lg:mb-0 lg:pt-2 xl:pt-2">
                    <img src={green_switch} alt="" class="absolute object-contain inset-0 z-10 scale-75 lg:scale-[70%] -mt-14 ml-16 md:ml-32 md:-mt-32 lg:ml-52 lg:-mt-40 xl:-mt-[16rem] mt-[0] xl:scale-[65%] xl:ml-96 2xl:ml-[22rem]" />
                    <div class="mx-auto py-10 md:py-24 lg:py-48 relative z-10 text-white">
                        <div class="mx-auto lg:max-w-5xl">
                            <h1 class="text-left lg:text-5xl md:text-4xl text-3xl font-bold text-gray-700 lg:w-[38%] w-[90%] mb-2 lg:leading-[56px]"><span class="block">CPA Salary</span><span class="block">In India and US</span></h1>

                            <div className="scale-[60%] md:scale-75 lg:scale-100 mt-5 md:mt-4 lg:mt-10 flex flex-row gap-10 -ml-24 md:-ml-28 lg:ml-0 items-start justify-start gap-x-2 lg:gap-x-6">
                                <div className="box box_btn transform transition-transform duration-300 hover:scale-110" tabindex="0">
                                    <Link to="https://www.kcglobed.com/contactus#EnquireForm"
                                        className="relative lg:top-[33px] bg-[#fbb03b] transition duration-300 rounded-3xl bg-primary px-6 py-4 text-sm font-semibold text-gray-700 shadow-sm hover:bg-primary hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary pb-4 cursor-pointer"
                                    >
                                        Enquiry Now
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bg-[#f2f2f2] relative lg:py-10 lg:px-10 py-0 pt-[71px] pb-[121px]">
                <img src={purpledot} alt="purpledot" className='absolute w-[91px] left-[21px] top-[2rem]' />
                <div class="flex flex-col items-center">
                    <div class="relative overflow-hidden">
                        <div class="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8 py-10">
                            <div class="max-w-3xl text-center mx-auto">
                                <h2 class="block uppercase text-2xl md:text-3xl font-bold text-gray-800">
                                    CPA Salary
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div class="lg:max-w-5xl px-4 py-6 justify-center items-center">
                        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-10 justify-center items-center">
                            <div tabindex="0" style={{ transform: "none" }}>
                                <div
                                    class="group flex flex-col lg:h-[26rem] rounded-xl transition bg-white transform transition-transform duration-300 hover:scale-110"
                                    href="#"
                                >
                                    <div
                                        class="relative overflow-hidden"
                                        style={{ width: "fit-content" }}
                                    >
                                        <div style={{ opacity: "1", transform: "none" }}>
                                            <div class="p-6 flex-grow">
                                                <div class="grow flex flex-col items-start">
                                                    <h3 class="text-2xl font-semibold text-[#6C38CC] min-w-[186px] mb-3">
                                                        <span className='block uppercase text-xl text-[#000]'>US CPA</span> <span className='text-[25px]'>Salary in India</span> 
                                                    </h3>
                                                </div>

                                                <p class="text-gray-700  text-[16px] mb-2">
                                                    Obtaining a US CPA credential can also significantly boost your earning potential in India. The US CPA salary in India is competitive and reflects the high demand for US-qualified CPAs:
                                                </p>
                                                <p class="text-gray-700  text-[16px] mb-2">
                                                    <span className='w-[20px] float-left h-[50px] mr-2'><img src={greenTickFill} className='w-[20px] inline-block' alt="" /></span>
                                                    <strong>Entry-Level CPAs</strong> : Earn between ₹8,00,000 and ₹12,00,000 per year.
                                                </p>
                                                <p class="text-gray-700  text-[16px] mb-2">
                                                    <span className='w-[20px] float-left h-[50px] mr-2'><img src={greenTickFill} className='w-[20px] inline-block' alt="" /></span>
                                                    <strong>Mid-Level CPAs</strong> : With several years of experience, salaries range from ₹12,00,000 to ₹25,00,000 per year.
                                                </p>
                                                <p class="text-gray-700  text-[16px] mb-2">
                                                    <span className='w-[20px] float-left h-[50px] mr-2'><img src={greenTickFill} className='w-[20px] inline-block' alt="" /></span>
                                                    <strong>Senior-Level CPAs</strong> : Those in senior positions or with extensive experience can earn ₹25,00,000 to ₹75,00,000 or more annually.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div tabindex="0" style={{ transform: "none" }}>
                                <div
                                    class="group flex flex-col lg:h-[26rem] rounded-xl transition bg-white transform transition-transform duration-300 hover:scale-110"
                                    href="#"
                                >
                                    <div
                                        class="relative overflow-hidden"
                                        style={{ width: "fit-content" }}
                                    >
                                        <div style={{ opacity: "1", transform: "none" }}>
                                            <div class="p-6 flex-grow">
                                                <div class="grow flex flex-col items-start">
                                                    <h3 class="text-2xl font-semibold text-[#6C38CC] min-w-[186px] mb-3">
                                                        <span className='block uppercase text-xl text-[#000]'>CPA</span> <span className='text-[25px]'>Salary in the US</span> 
                                                    </h3>
                                                </div>

                                                <p class="text-gray-700  text-[16px] mb-2">
                                                    The earning potential for CPAs in the United States is substantial, reflecting the value of the CPA credential in the accounting profession. Here are some insights into the CPA salary in the US:
                                                </p>
                                                <p class="text-gray-700  text-[16px] mb-2">
                                                    <span className='w-[20px] float-left h-[50px] mr-2'><img src={greenTickFill} className='w-[20px] inline-block' alt="" /></span>
                                                    <strong>Entry-Level CPAs</strong> : Typically earn between $55,000 and $75,000 per year.
                                                </p>
                                                <p class="text-gray-700  text-[16px] mb-2">
                                                    <span className='w-[20px] float-left h-[50px] mr-2'><img src={greenTickFill} className='w-[20px] inline-block' alt="" /></span>
                                                    <strong>Mid-Level CPAs</strong> : With 5-10 years of experience, salaries range from $75,000 to $120,000 per year.
                                                </p>
                                                <p class="text-gray-700  text-[16px] mb-2">
                                                    <span className='w-[20px] float-left h-[50px] mr-2'><img src={greenTickFill} className='w-[20px] inline-block' alt="" /></span>
                                                    <strong>Senior-Level CPAs</strong> : Those with more than 10 years of experience or in managerial roles can earn $120,000 to $200,000 or more annually.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <img src={yellowdot} alt="yellowdot" className='w-[51px] absolute bottom-[2rem] right-[21px]' />
            </div>
            <div class="p-4 md:p-8 lg:p-10">
                <div className="flex flex-col items-center">
                    <div className="relative overflow-hidden">
                        <div className="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8 pt-10">
                            <div className="max-w-3xl text-center mx-auto">
                                <h2 className="block text-2xl md:text-4xl font-bold text-gray-800">CPA</h2>
                                <h2 className="mt-2 block text-2xl md:text-4xl font-bold text-primary_text"> Salary In India and US </h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col items-center">
                    <div tabindex="0" style={{ transform: 'none' }}>
                        <div class="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 items-center xs:max-w-xl lg:max-w-6xl group h-full">
                            <div class="flex flex-col ml-0 lg:ml-6">
                                <h3 className='font-sans text-3xl text-gray-700 font-semibold text-center'>Auditing and Assurance</h3>
                                <img className='w-[100%]' src={slry1} alt="slry1" />
                            </div>
                            <div class="flex flex-col ml-0 lg:ml-6 pt-6">
                                <h3 className='font-sans text-3xl text-gray-700 font-semibold text-center'>Management / Business Consulting</h3>
                                <img className='w-[100%]' src={slry2} alt="slry2" />
                            </div>
                        </div>
                    </div>
                    <div tabindex="0" style={{ transform: 'none' }}>
                        <div class="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 items-center xs:max-w-xl lg:max-w-6xl group h-full">
                            <div class="flex flex-col ml-0 lg:ml-6">
                                <h3 className='font-sans text-3xl text-gray-700 font-semibold text-center'>Financial Plannning and Analysis</h3>
                                <img className='w-[100%]' src={slry3} alt="slry3" />
                            </div>
                            <div class="flex flex-col ml-0 lg:ml-6 pt-6">
                                <h3 className='font-sans text-3xl text-gray-700 font-semibold text-center'>International Taxation</h3>
                                <img className='w-[100%]' src={slry4} alt="slry4" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UsCpaSalary;
